<template>
  <div class="wrapper">
    <div class="header">
      <span>{{ title }}</span>
    </div>
    <div class="search_wrapper">
      <div class="input_wrapper">
        <input v-model="type" class="radio_input" name="type" type="radio" value="1" @change="onChangeType">
        <label class="radio_label" for="">
          {{ $t('project_management.project_detail.input_label.project_resource_less_than_20') }}
        </label>
      </div>
      <div class="input_wrapper">
        <input v-model="type" class="radio_input" name="type" type="radio" value="2" @change="onChangeType">
        <label class="radio_label" for="">{{
            $t('project_management.project_detail.input_label.project_resource_top_20')
          }}</label>
      </div>
      <select2 v-model="departmentCode" :options="division_options"
               :settings="{ minimumResultsForSearch: -1 }"
               class="select__unit" @change="onChangeDepartmentCode"/>
    </div>
    <v-chart
      id="main"
      ref="chart"
      :option="option"
      autoresize
      style="min-height: 590px; min-width: 500px;"
    />
    <div class="button_wrapper">
      <div class="previous_button_wrapper">
        <img alt="" class="icon" src="@/assets/icons/previous_arrow.svg" @click="onClickPreviousButton"/>
        <span class="text" @click="onClickPreviousButton">
         {{ $t('project_management.project_detail.button_title.project_resource_effort_previous_button') }}
      </span>
      </div>
      <div :class="[ isCurrentWeek ? 'disabled' : '' ]" class="next_button_wrapper">
      <span class="text" @click="onClickNextButton">
         {{ $t('project_management.project_detail.button_title.project_resource_effort_next_button') }}
      </span>
        <img alt="" class="icon" src="@/assets/icons/next_arrow.svg" @click="onClickNextButton"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {use, setOptions} from "echarts/core";
import {CanvasRenderer} from "echarts/renderers";
import {PieChart} from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GraphicComponent
} from "echarts/components";
import VChart from "vue-echarts";
import {mapGetters} from "vuex";
import {TimelineComponent, MarkPointComponent} from 'echarts/components';

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  TimelineComponent,
  MarkPointComponent,
  GraphicComponent
]);

const division_options = [
  {
    text: "Tất cả",
    id: "all",
    disabled: false,
    selected: true
  },
  {
    text: "Khối phát triển số 1",
    id: "SOFTWARE_DEVELOPMENT",
    disabled: false
  },
  {
    text: "Khối phát triển số 2",
    id: "SOFTWARE_DEVELOPMENT_2",
    disabled: false
  },
];

const colors = ['#01959E', '#EA6057'];
const yAxisData = [0, 20, 40, 60, 80, 100, 120, 140, 160, 180, 200];

export default {
  name: "ResourceEffort",
  components: {
    VChart,
  },
  props: {
    division: String,
    title: String
  },
  data() {
    return {
      statistics: [],
      isCurrentWeek: true,
      option: {
        title: {},
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'line',
          },
          formatter: (params) => {
            const day = moment(params.name, "DD/MM/YYYY").format("YYYY-MM-DD");
            const value = params.value;
            let string = "";
            Object.values(this.resourceEffortDayValues[day][value]).map(data => {
              const value = data.is_created === "true" ? `${params.value}%` : '-';
              string = string +
                `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${this.resourceEffortColors[data.id]};"></span>` +
                `<span style="width:40px;height:10px;font-weight: 600;font-family: 'Helvetica'">${data.name}:</span>` +
                `<span style="margin-left:4px; width:10px;height:10px">${value}</span>` +
                '<br/>';
            });
            return string;
          }
        },
        legend: {
          data: []
        },
        grid: {
          show: true,
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: [],
          splitLine: {
            show: false
          }
        },
        yAxis: {
          show: true,
          type: 'value',
          name: 'Effort (%)',
          position: 'left',
          axisLine: {
            show: true,
            symbolSize: [10, 15],
          },
          axisLabel: {
            formatter: '{value}'
          },
          min: 0,
          max: 200,
          splitNumber: 10,
          axisTick: {
            show: false
          },
          textStyle: {
            fontFamily: 'Helvetica'
          }
        },
        markPoint: {
          symbol: 'circle',
        },
        series: [],
      },
      division_options,
      departmentCode: 'all',
      dateRange: [],
      type: 1,
      startDate: moment().subtract(7, 'd'),
      endDate: moment(),
      currentWeekNumber: moment().week(),
      today: moment(),
      weekIndex: moment().week(),
      loadingOpts: {
        // text: 'loading',
        color: '#c23531',
        textColor: '#000',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        zlevel: 0,
        // Font size. Available since `v4.8.0`.
        fontSize: 12,
        // Show an animated "spinner" or not. Available since `v4.8.0`.
        showSpinner: true,
        // Radius of the "spinner". Available since `v4.8.0`.
        spinnerRadius: 10,
        // Line width of the "spinner". Available since `v4.8.0`.
        lineWidth: 10,
        // Font thick weight. Available since `v5.0.1`.
        fontWeight: 'normal',
        // Font style. Available since `v5.0.1`.
        fontStyle: 'normal',
        // Font family. Available since `v5.0.1`.
        fontFamily: 'sans-serif'
      }
    };
  },
  computed: {
    ...mapGetters({
      resourceEffortStatistics: "project/resourceEffortStatistics",
      resourceEffortDayValues: "project/resourceEffortDayValues",
      resourceEffortColors: "project/resourceEffortColors",
    }),
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const params = {
        start_date: this.startDate.format('YYYY-MM-DD'),
        end_date: this.endDate.format('YYYY-MM-DD'),
        type: this.type,
        department: this.departmentCode,
        is_current_week: this.isCurrentWeek
      };
      await this.$store.dispatch('project/getResourceEffortStatistics', {params});
      this.$refs.chart.clear();
      this.option.xAxis.data = this.getDateRange(this.startDate, this.endDate);
      this.option.legend.data = this.getDateRange(this.startDate, this.endDate);
      this.option.series = this.resourceEffortStatistics.map(record => {
        return {
          name: record.name,
          data: Object.entries(record.efforts).map(effort => {
            return effort[1].effort;
          }),
          type: "line",
          symbol: "circle",
          symbolSize: 10,
          emphasis: {
            focus: 'series'
          },
          lineStyle: {
            color: this.resourceEffortColors[record.id],
            width: 3
          },
          itemStyle: {color: this.resourceEffortColors[record.id]}
        };
      });
    },
    getDateRange(startDate = moment().startOf('week').add('days', 1), endDate = moment().endOf('week').add('days', 1)) {
      let now = startDate.clone(),
        dates = [];
      while (now.isSameOrBefore(endDate)) {
        dates.push(now.format('DD/MM/YYYY'));
        now.add(1, 'days');
      }
      return dates;
    },
    onChangeType() {
      this.getData();
    },
    onChangeDepartmentCode() {
      this.getData();
    },
    onClickPreviousButton() {
      this.weekIndex -= 1;
      this.handleClickButton(this.startDate.subtract(7, 'd'), this.endDate.subtract(7, 'd'), this.weekIndex);
    },
    onClickNextButton() {
      this.weekIndex += 1;
      this.handleClickButton(this.startDate.add(7, 'd'), this.endDate.add(7, 'd'), this.weekIndex);
    },
    handleClickButton(startDate, endDate, weekIndex) {
      this.isCurrentWeek = weekIndex === this.currentWeekNumber;
      this.startDate = startDate;
      this.endDate = (weekIndex === this.currentWeekNumber ? moment() : endDate);
      this.option.xAxis.data = this.getDateRange(this.startDate, this.endDate);
      this.getData();
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .header {
    width: 100%;
    background: #17A896;
    border-radius: 10px;
    padding: 12px;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.0703846px;
    color: #FFFFFF;
  }

  .disabled {
    pointer-events: none;

    .text {
      color: #DADADA;
    }

    .icon {
      color: #DADADA;
    }
  }

  .search_wrapper {
    width: 100%;
    display: flex;
    justify-content: end;
    padding: 20px 0;

    .input_wrapper {
      display: flex;
      align-items: center;
      margin-right: 25px;

      .radio_input {
        width: 16px;
        height: 16px;
        margin: 0 12px 0 0;
      }

      .radio_label {
        font-weight: 400;
        font-size: 14px;
        margin: 0;
      }
    }

    /deep/ .select2 {
      width: 170px !important;
      z-index: 2;

      &-selection {
        border: 1px solid #CFCFCF !important;
        height: 40px !important;
        //border-radius: 10px;

        &__rendered {
          height: 100% !important;
          vertical-align: middle !important;
          display: flex !important;
          align-items: center !important;
        }

        &__arrow {
          height: 100% !important;
        }
      }
    }
  }

  .button_wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .previous_button_wrapper,
    .next_button_wrapper {
      .text {
        font-weight: 400;
        font-size: 12px;
        cursor: pointer;
      }

      .icon {
        height: 12px;
        width: 12px;
        cursor: pointer;
      }
    }
  }
}

/deep/ .select2-dropdown {
  width: 167px;
  z-index: 1;
  left: 2px;
  top: -5px;
}
</style>
